import { AppDispatch } from '../../../../@types/store'
import { uploadMultimediaAttachment } from '../../../../api/multimedia/multimediaApi'
import { addPersistedAttachmentFromExternalSource } from '../../../../redux/reducers/multimedia/multimediaFeature'
import { normalizeMultimediaAttachmentTitle } from './aiUploadedAttachmentsPure'

/** After a successful upload API response: fix title edge cases, dispatch into Redux multimedia state, return the attachment used for UI/extraction. */
export const persistMultimediaAttachmentToStore = (
  dispatch: AppDispatch,
  attachment: Awaited<ReturnType<typeof uploadMultimediaAttachment>>,
  fallbackTitle: string
) => {
  const attachmentTitle = normalizeMultimediaAttachmentTitle(attachment.title, fallbackTitle)
  const normalizedAttachment = {
    ...attachment,
    title: attachmentTitle,
  }

  dispatch(
    addPersistedAttachmentFromExternalSource({
      attachment: normalizedAttachment,
      fallbackTitle: attachmentTitle,
    })
  )

  return normalizedAttachment
}
